export const fillingInput = ( pointOfSale ) => {
    return pointOfSale.map(({name,id, reference_name}) => {
        return {
            reference_name:reference_name,
            label:name,
            value:id
        }
    })
}